const carousels = async function () {
    const baseCarousels = [...document.querySelectorAll(".base-carousel")];


    if (baseCarousels) {
        const Swiper = await (await import("swiper/bundle")).default;

        if (baseCarousels) {
            baseCarousels.forEach(section => {
                const carousel = new Swiper(section.querySelector(".swiper"), {
                    slidesPerView: 1,
                    lazy: true,
                    // loop: true,
                    speed: 800,
                    pagination: {
                        el: section.querySelector(".swiper-pagination"),
                        type: 'bullets',
                        clickable: true,
                    },
                    navigation: {
                        nextEl: section.querySelector(".swiper-next-el"),
                        prevEl: section.querySelector(".swiper-prev-el"),
                    },
                })
            })
        }
    
    }
}

export const init = carousels;